import { render, staticRenderFns } from "./dialog2.vue?vue&type=template&id=07b77814&scoped=true"
import script from "./dialog2.vue?vue&type=script&lang=js"
export * from "./dialog2.vue?vue&type=script&lang=js"
import style0 from "./dialog2.vue?vue&type=style&index=0&id=07b77814&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b77814",
  null
  
)

export default component.exports